import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL as string;

export const obtenerMonedas = async () => {
  try {
    const response = await axios.get(`${API_URL}/monedas`);
    return response.data; 
  } catch (error) {
    console.error("Error al obtener las monedas:", error);
    throw error; 
  }
};
